import { PhoneFilter } from 'filters/phone';

export const FormatPhoneNumber = angular
    .module('checkout.directives.formatPhoneNumber', [
        PhoneFilter
    ]).directive('formatPhoneNumber', ($filter) => {
        return {
            require: '?ngModel',
            link: (scope, elem, attrs, ctrl) => {
                if (!ctrl) {
                    return;
                }

                ctrl.$formatters.unshift(() => {
                    return $filter('vPhone')(ctrl.$modelValue || '');
                });

                ctrl.$parsers.unshift((viewValue) => {
                    var plainNumber = viewValue.replace(/[^\d]+/g, '');
                    elem.val($filter('vPhone')(plainNumber));
                    return plainNumber;
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/formatPhoneNumber.js